<div *ngIf="this.breadcrumbItems.length > 1" class="breadcrump-container">
    <ng-container *ngFor="let breadcrumbItem of this.breadcrumbItems; let i = index;">
        <a *ngIf="breadcrumbItem.routerLink" routerLink="{{ breadcrumbItem.routerLink }}"><span>{{ breadcrumbItem.title }}</span></a>
        <span *ngIf="!breadcrumbItem.routerLink">{{ breadcrumbItem.title }}</span>
        <mat-icon *ngIf="i !== breadcrumbItems.length - 1" aria-hidden="false" aria-label="keyboard_arrow_right icon" fontIcon="keyboard_arrow_right"></mat-icon>
    </ng-container>
</div>
